// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__32EHf","list":"PatternAutocomplete_list__2NFY0"};